import "./HeroBanner.scss";
import { useContext, useEffect, useRef, useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { RiArrowDownSLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import axios from "axios";

const HeroBanner = () => {
  const [allAnnouncements, setAllAnnouncements] = useState([]);
  const { backendUrl } = useContext(AppContext);
  const [allNews, setAllNews] = useState([]);
  const lines = Array.from({ length: 20 });
  const navigate = useNavigate();
  const vidRef = useRef();
  const [allVideos, setAllVideos] = useState([])

  async function fetchAnnouncements() {
    try {
      const { data } = await axios.get(`${backendUrl}/api/auth/getAllAnnouncements`);
      if (data.success) {
        setAllAnnouncements(data.announcements);
      } else {
        setAllAnnouncements([]);
      }
    } catch (error) {
      console.error("No internet Connection");
    }
  }

  async function fetchAllNews() {
    try {
      const { data } = await axios.get(`${backendUrl}/api/auth/getAllNews`);
      if (data.success) {
        setAllNews(data.news);
      } else {
        setAllNews([]);
      }
    } catch (error) {
      console.error("No internet Connection");
    }
  }

  async function fetchAllEventVideos() {
    try {
      const { data } = await axios.get(`${backendUrl}/api/auth/getAllEventsVideos`);
      if (data.success) {
        setAllVideos(data.data);
      } else {
        setAllVideos([]);
      }
    } catch (error) {
      console.error("No internet Connection");
    }
  }

  useEffect(() => {
    fetchAnnouncements();
    fetchAllNews();
    fetchAllEventVideos();
  }, [])

  return (
    <main className="main">
      <div className="background">
        <div className="book-content">
          <svg
            className="svg-file"
            width="100%"
            height="auto"
            viewBox="0 0 376 329"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M186.5 31.6076 C128.529 -15.1433 50.0128 7.3179 11.4426 27.4646 
      C6.75578 29.9127 4 34.8358 4 40.1235 V306.609 C4 326.609 15.3333 326.276 21 323.609 
      C80.6612 283.583 149.472 303.383 181.246 320.588 C184.531 322.367 188.518 322.367 
      191.774 320.536 C262.113 280.98 324.138 303.003 349.833 321.239 C351.959 322.748 
      354.365 323.903 356.971 323.996 C371.49 324.513 372 313.426 372 306.609 V44.2274 
      C372 39.1625 369.457 34.3992 365.11 31.8 C287.979 -14.3177 214.339 12.024 186.5 31.6076 Z"
              fill="#09573A"
              fillOpacity="0.6"
              stroke="#178F62"
              strokeWidth="7"
              className="path-2"
            />
          </svg>

          <div className="book-text">
            <b className="content-1">
              DEDICATED TO <br />
              MAKE <br />
              EXCELLENCE
            </b>
            <small style={{ color: "#23C085" }} className="content-2">
              SINCE 2001
            </small>
          </div>

          <div className="arrow">
            <RiArrowDownSLine
              className="blinking-arrow1"
              size={42}
              style={{ color: "#23C085" }}
            />
            <RiArrowDownSLine
              className="blinking-arrow2"
              size={42}
              style={{ color: "#23C085" }}
            />
          </div>
        </div>
        <div className="outer-box">
          <div className="first-box-outer">
            <div className="inbox-1 announcement-box">
              <h3 className="green">ANNOUNCEMENT</h3>
              <div className="para-with-code">
                <marquee
                  className="marquee-style"
                  height="175.5px"
                  direction="up"
                  key={allAnnouncements.length}
                  onMouseOver={(event) => {
                    event.currentTarget.stop();
                  }}
                  onMouseLeave={(event) => {
                    event.currentTarget.start();
                  }}
                >
                  {allAnnouncements
                    .filter((announcement) => announcement.isActive)
                    .map((announcement) => (
                      <div>
                        {announcement.recent ? (
                          <button className="new-btn">
                            <span className="btn-text">New</span>
                          </button>
                        ) : ""}
                        <br />
                        <p key={announcement.id}>
                          {announcement.announcement}
                        </p>
                      </div>
                    ))}
                </marquee>
                <div className="para-right-code"></div>
              </div>
            </div>

            <div className="inbox-1 inbox-1-img">
              <h3 className="green">EVENT</h3>
              <div className="video-list" style={{scrollBehavior:"smooth", overflowY:"scroll"}}>
                {allVideos?.filter((video) => video.isActive !== false).map((video) => (
                  <div key={video.id} className="video-card">
                    <video
                      controls
                      muted
                      autoPlay
                      loop
                      height={200}
                      className="event-video"
                    >
                      <source
                        src={`data:${video.contentType};base64,${video.data}`}
                        type={video.contentType}
                      />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                ))}
              </div>

            </div>
            <div className="inbox-1">
              <h3 className="green">NEWS</h3>
              <div className="para-with-left">
                <div className="para-left-code"></div>
                <marquee
                  className="marquee-style"
                  behavior=""
                  direction="up"
                  height="175.5px"
                  key={allAnnouncements.length}
                  onMouseOver={(event) => {
                    event.currentTarget.stop();
                  }}
                  onMouseLeave={(event) => {
                    event.currentTarget.start();
                  }}
                >
                  {allNews
                    .filter((news) => news.isActive)
                    .map((news) => (
                      <div>
                        {news.recent ? (
                          <button className="new-btn">
                            <span className="btn-text">New</span>
                          </button>
                        ) : ""}
                        <br />
                        <p key={news.id}>{news.news}</p>
                      </div>
                    ))}
                </marquee>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="green-box">
        <div className="outer">
          <button
            onClick={() => navigate("/academics/ug-programmes")}
            className="outer-in"
          >
            <h3> UG PROGRAMMES</h3>
            <div className="right-triangle"></div>
          </button>
          <div className="white-code" style={styles.container}>
            {lines.map((_, index) => (
              <div key={index} style={styles.line}></div>
            ))}
          </div>

          <button
            onClick={() => navigate("/academics/pg-programmes")}
            className="outer-in"
          >
            <h3>PG PROGRAMMES</h3>
            <div className="right-triangle"></div>
          </button>
          <div className="white-code" style={styles.container}>
            {lines.map((_, index) => (
              <div key={index} style={styles.line}></div>
            ))}
          </div>
          <button
            onClick={() => navigate("/academics/research")}
            className="outer-in"
          >
            <h3>RESEARCH</h3>
            <div className="right-triangle"></div>
          </button>
        </div>
      </div>
    </main>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "40vh",
  },
  line: {
    width: "25px",
    height: "1px",
    backgroundColor: "white",
    transform: "rotate(40deg) skew(70deg)",
    margin: "3px",
  },
};

export default HeroBanner;
